import { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';

import { Box, CircularProgress } from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';

const LoadingComponent = () => {
  const isLoading = useSelector((state) => !!state?.common?.loading?.length);

  const [progress, setProgress] = useState(0);

  const timer = useRef(null);

  const increaseProgress = () => {
    setProgress((oldProgress) =>
      Math.min(oldProgress + Math.random() * 10, 100),
    );
  };

  useEffect(() => {
    if (isLoading) {
      timer.current = setInterval(() => increaseProgress(), 100);
    } else {
      timer.current && clearInterval(timer.current);
      setProgress(0);
    }
  }, [isLoading]);

  useEffect(() => () => timer.current && clearInterval(timer.current), []);

  return (
    isLoading && (
      <Box sx={{ position: 'fixed', top: 0, right: 0, left: 0, zIndex: 9999 }}>
        <LinearProgress variant="determinate" value={progress} />
      </Box>
    )
  );
};

export const CircularLoaderComponent = () => (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    padding="5rem"
  >
    <CircularProgress disableShrink />
  </Box>
);

export default LoadingComponent;
